import React from "react";

const KioskImage = () => (
  <svg
    width="184"
    height="170"
    viewBox="0 0 184 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Illustration - Kiosk">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H184V170H4C1.79086 170 0 168.209 0 166V4Z"
        fill="#D9DAF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8395 66.0752C15.8139 66.0756 15.7883 66.0758 15.7626 66.0758C13.1713 66.0758 11.0706 63.981 11.0706 61.3968C11.0706 58.8126 13.1713 56.7178 15.7626 56.7178C16.821 56.7178 17.7976 57.0673 18.5826 57.6568C19.3979 54.9822 21.8905 53.0359 24.839 53.0359C28.2497 53.0359 31.0504 55.6404 31.3504 58.9638C32.0333 58.4221 32.8979 58.0985 33.8382 58.0985C36.0472 58.0985 37.838 59.8843 37.838 62.0871C37.838 64.29 36.0472 66.0758 33.8382 66.0758C33.7868 66.0758 33.7355 66.0749 33.6845 66.0729V66.0761H15.8395V66.0752Z"
        fill="#A99DD2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2482 96.1525C20.2357 96.1527 20.2232 96.1528 20.2107 96.1528C18.9455 96.1528 17.9199 95.13 17.9199 93.8684C17.9199 92.6067 18.9455 91.5839 20.2107 91.5839C20.7274 91.5839 21.2042 91.7545 21.5875 92.0424C21.9855 90.7365 23.2025 89.7863 24.6421 89.7863C26.3074 89.7863 27.6748 91.058 27.8212 92.6807C28.1546 92.4163 28.5767 92.2582 29.0359 92.2582C30.1144 92.2582 30.9887 93.1301 30.9887 94.2057C30.9887 95.2812 30.1144 96.1531 29.0359 96.1531C29.0107 96.1531 28.9857 96.1526 28.9608 96.1517V96.153H20.2482V96.1525Z"
        fill="#A99DD2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.3391 82.7851C53.3583 82.7854 53.3775 82.7856 53.3968 82.7856C55.3379 82.7856 56.9114 81.1728 56.9114 79.1834C56.9114 77.194 55.3379 75.5812 53.3968 75.5812C52.604 75.5812 51.8724 75.8503 51.2844 76.3042C50.6737 74.2451 48.8066 72.7467 46.598 72.7467C44.043 72.7467 41.945 74.752 41.7205 77.3107C41.2089 76.8937 40.5613 76.6445 39.8568 76.6445C38.2021 76.6445 36.8608 78.0193 36.8608 79.7152C36.8608 81.4111 38.2021 82.786 39.8568 82.786C39.8954 82.786 39.9338 82.7852 39.972 82.7837V82.7858H53.3391V82.7851Z"
        fill="#A99DD2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M147.427 54.9962C147.349 55.0028 147.27 55.0062 147.191 55.0062C145.669 55.0062 144.435 53.7759 144.435 52.2583C144.435 50.7407 145.669 49.5104 147.191 49.5104C147.376 49.5104 147.557 49.5287 147.732 49.5635C148.228 47.724 149.913 46.37 151.914 46.37C153.778 46.37 155.367 47.5448 155.977 49.1926C156.176 49.0946 156.401 49.0396 156.638 49.0396C157.195 49.0396 157.681 49.3431 157.938 49.7933C158.306 49.6122 158.719 49.5104 159.157 49.5104C160.679 49.5104 161.913 50.7407 161.913 52.2583C161.913 53.7759 160.679 55.0062 159.157 55.0062C159.131 55.0062 159.105 55.0058 159.079 55.0051V55.0062H147.427V54.9962Z"
        fill="#A99DD2"
      />
      <path
        d="M113.722 121.759C113.722 123.913 103.373 125.658 90.6076 125.658C77.8422 125.658 67.4937 123.913 67.4937 121.759C67.4937 119.606 77.8422 117.861 90.6076 117.861C103.373 117.861 113.722 119.606 113.722 121.759Z"
        fill="#A99DD2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.373 44.9017C66.8298 44.9017 65.2658 44.7039 65.2658 47.5112V111.107C65.2658 113.914 66.7969 113.962 68.3401 113.962H113.712C115.255 113.962 116.506 113.914 116.506 111.107L116.473 47.7569C116.473 44.9496 114.629 44.9017 113.086 44.9017H68.373Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.473 47.7569C116.473 44.9496 114.629 44.9017 113.086 44.9017H68.373C68.2775 44.9017 68.1818 44.9009 68.0864 44.9002C66.6421 44.8887 65.2658 44.8778 65.2658 47.5112V111.107C65.2658 113.914 66.7969 113.962 68.3401 113.962H113.712C115.255 113.962 116.506 113.914 116.506 111.107L116.473 47.7569ZM114.278 111.107L114.246 47.7569C114.246 47.4665 114.216 47.2916 114.192 47.1986C114.147 47.1877 114.082 47.1751 113.992 47.164C113.756 47.1347 113.48 47.1295 113.086 47.1295H68.373C68.2686 47.1295 68.1654 47.1287 68.0724 47.128L68.0662 47.1279C67.9685 47.1272 67.8818 47.1265 67.7973 47.1265C67.6857 47.1266 67.5918 47.1279 67.5103 47.1309C67.5007 47.2284 67.4937 47.3535 67.4937 47.5112V111.107C67.4937 111.393 67.516 111.585 67.5388 111.707C67.7259 111.729 67.9635 111.734 68.3401 111.734H113.712C113.945 111.734 114.113 111.732 114.243 111.726C114.263 111.584 114.278 111.383 114.278 111.107Z"
        fill="#292A33"
      />
      <path
        d="M71.4335 51.5818C71.4337 51.2743 71.683 51.0253 71.9904 51.0253H104.253C104.561 51.0253 104.81 51.2746 104.81 51.5822V100.038C104.81 100.346 104.561 100.595 104.253 100.595H71.9498C71.6421 100.595 71.3926 100.345 71.3929 100.037L71.4335 51.5818Z"
        fill="#D9DAF9"
      />
      <rect
        x="158.685"
        y="105.959"
        width="11.9666"
        height="2.51258"
        rx="1.25629"
        fill="#292A33"
      />
      <path
        d="M115.392 106.164H153.823C154.438 106.164 154.937 106.663 154.937 107.278C154.937 107.894 154.438 108.392 153.823 108.392H115.392V106.164Z"
        fill="#292A33"
      />
      <path
        d="M31.2912 107.278C31.2912 106.663 31.7899 106.164 32.4051 106.164H66.9367V108.392H32.4051C31.7899 108.392 31.2912 107.894 31.2912 107.278Z"
        fill="#292A33"
      />
      <rect
        x="20.5965"
        y="105.959"
        width="7.71443"
        height="2.5123"
        rx="1.25615"
        fill="#292A33"
      />
      <rect
        x="92.557"
        y="106.164"
        width="7.71443"
        height="2.5123"
        rx="1.25615"
        fill="#292A33"
      />
      <rect
        x="111.221"
        y="92.7974"
        width="7.71443"
        height="2.5123"
        rx="1.25615"
        transform="rotate(90 111.221 92.7974)"
        fill="#292A33"
      />
      <rect
        x="103.696"
        y="106.164"
        width="7.71443"
        height="2.5123"
        rx="1.25615"
        fill="#292A33"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.7816 69.3803C95.1918 69.3803 94.6563 69.8101 94.5091 70.4474C94.4068 70.8904 93.964 71.1667 93.5201 71.0646C93.0762 70.9625 92.7993 70.5206 92.9016 70.0777C93.2063 68.7581 94.3586 67.7341 95.7816 67.7341C97.2046 67.7341 98.3569 68.7581 98.6616 70.0777C98.764 70.5206 98.487 70.9625 98.0431 71.0646C97.5992 71.1667 97.1564 70.8904 97.0541 70.4474C96.9069 69.8101 96.3714 69.3803 95.7816 69.3803Z"
        fill="#404064"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.4203 69.3803C79.8305 69.3803 79.2951 69.8101 79.1479 70.4474C79.0455 70.8904 78.6027 71.1667 78.1588 71.0646C77.7149 70.9625 77.438 70.5206 77.5403 70.0777C77.8451 68.7581 78.9973 67.7341 80.4203 67.7341C81.8434 67.7341 82.9956 68.7581 83.3004 70.0777C83.4027 70.5206 83.1258 70.9625 82.6818 71.0646C82.2379 71.1667 81.7951 70.8904 81.6928 70.4474C81.5456 69.8101 81.0102 69.3803 80.4203 69.3803Z"
        fill="#404064"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.8492 79.9152C83.3048 79.9152 83.6741 80.2837 83.6741 80.7383C83.6741 81.4275 84.234 81.9861 84.9246 81.9861H91.2784C91.969 81.9861 92.5289 81.4275 92.5289 80.7383C92.5289 80.2837 92.8982 79.9152 93.3538 79.9152C93.8094 79.9152 94.1788 80.2837 94.1788 80.7383C94.1788 82.3367 92.8802 83.6325 91.2784 83.6325H84.9246C83.3228 83.6325 82.0242 82.3367 82.0242 80.7383C82.0242 80.2837 82.3936 79.9152 82.8492 79.9152Z"
        fill="#404064"
      />
      <path
        d="M116.506 58.5392H151.249C151.801 58.5392 152.249 58.9869 152.249 59.5392V66.3323C152.249 66.8846 151.801 67.3324 151.249 67.3324H116.506V58.5392Z"
        fill="#8F8CF0"
      />
      <rect
        x="141.699"
        y="61.9937"
        width="7.08469"
        height="1.88422"
        rx="0.942111"
        fill="#FEFEFE"
      />
      <rect
        x="134.929"
        y="61.9937"
        width="4.25081"
        height="1.88422"
        rx="0.942111"
        fill="#FEFEFE"
      />
      <rect
        x="122.332"
        y="61.9937"
        width="10.0771"
        height="1.88444"
        rx="0.942218"
        fill="#FEFEFE"
      />
      <path
        d="M116.506 61.9937H118.87C119.391 61.9937 119.813 62.4154 119.813 62.9358C119.813 63.4561 119.391 63.8779 118.87 63.8779H116.506V61.9937Z"
        fill="#FEFEFE"
      />
      <rect
        x="123.73"
        y="66.0762"
        width="50.7006"
        height="8.79317"
        rx="1.5"
        fill="#B4B3F4"
      />
      <rect
        x="160.259"
        y="69.5306"
        width="10.707"
        height="1.88444"
        rx="0.942218"
        fill="#FEFEFE"
      />
      <rect
        x="144.514"
        y="69.5306"
        width="13.2262"
        height="1.88444"
        rx="0.942218"
        fill="#FEFEFE"
      />
      <rect
        x="137.428"
        y="69.5306"
        width="4.56569"
        height="1.88422"
        rx="0.942111"
        fill="#FEFEFE"
      />
      <rect
        x="127.194"
        y="69.5306"
        width="7.71443"
        height="1.88422"
        rx="0.942111"
        fill="#FEFEFE"
      />
      <path
        d="M116.506 94.1898V97.1663L124.357 101.424C125.023 101.785 125.848 101.663 126.38 101.125L136.503 90.8855H133.039L125.398 98.8104C125.262 98.9514 125.047 98.9814 124.878 98.883L116.506 94.1898Z"
        fill="#6145F7"
      />
      <path
        d="M129.316 89.6295C129.316 88.9356 129.88 88.3732 130.575 88.3732H140.969C141.664 88.3732 142.228 88.9356 142.228 89.6295C142.228 90.3233 141.664 90.8858 140.969 90.8858H130.575C129.88 90.8858 129.316 90.3233 129.316 89.6295Z"
        fill="#6145F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.2849 99.6975C84.0428 99.7896 84.5824 100.477 84.4901 101.234C84.4309 101.719 84.4003 102.213 84.4003 102.716C84.4003 104.558 84.8114 106.3 85.5457 107.86C85.8703 108.55 85.5732 109.372 84.8821 109.695C84.1911 110.019 83.3677 109.723 83.0431 109.033C82.1397 107.114 81.6354 104.972 81.6354 102.716C81.6354 102.102 81.6728 101.496 81.7455 100.9C81.8378 100.144 82.527 99.6054 83.2849 99.6975Z"
        fill="#6145F7"
      />
      <path
        d="M65.5443 91.6835V94.7467L64.1232 95.4096C70.0803 98.0349 83.3328 103.878 83.3328 103.878V106.757L61.1761 96.9568C59.9803 96.4279 59.9361 94.6225 61.1044 94.0266L65.5443 91.6835Z"
        fill="#6145F7"
      />
      <rect
        x="125.975"
        y="68.4315"
        width="17.635"
        height="17.5863"
        rx="8.439"
        fill="#6145F7"
      />
      <path
        d="M135.726 72.5382V73.5822C137.038 73.8131 137.835 74.7158 137.819 75.8019L136.283 75.8282C136.189 75.1567 135.886 74.7472 135.084 74.7472C134.256 74.7473 133.745 75.1252 133.745 75.6759C133.745 76.1167 133.985 76.3377 134.803 76.5529L136.017 76.8517C137.387 77.1823 137.955 78.0118 137.955 79.1505C137.955 80.2943 137.085 81.0918 135.694 81.2755V82.215H134.381V81.2804C132.953 81.1177 132.031 80.4039 131.891 79.0763L133.475 79.045C133.636 79.7376 134.219 80.1055 135.053 80.1056C135.803 80.1056 136.34 79.7008 136.34 79.1603C136.34 78.5992 135.991 78.3682 135.257 78.2003L134.021 77.9327C132.87 77.6966 132.13 77.0196 132.114 75.8546C132.104 74.6162 133.063 73.7819 134.407 73.5773V72.5382H135.726Z"
        fill="white"
      />
      <mask
        id="mask0_9348_204"
        maskUnits="userSpaceOnUse"
        x="131"
        y="72"
        width="7"
        height="11"
      >
        <path
          d="M135.726 72.5382V73.5822C137.038 73.8131 137.835 74.7158 137.819 75.8019L136.283 75.8282C136.189 75.1567 135.886 74.7472 135.084 74.7472C134.256 74.7473 133.745 75.1252 133.745 75.6759C133.745 76.1167 133.985 76.3377 134.803 76.5529L136.017 76.8517C137.387 77.1823 137.955 78.0118 137.955 79.1505C137.955 80.2943 137.085 81.0918 135.694 81.2755V82.215H134.381V81.2804C132.953 81.1177 132.031 80.4039 131.891 79.0763L133.475 79.045C133.636 79.7376 134.219 80.1055 135.053 80.1056C135.803 80.1056 136.34 79.7008 136.34 79.1603C136.34 78.5992 135.991 78.3682 135.257 78.2003L134.021 77.9327C132.87 77.6966 132.13 77.0196 132.114 75.8546C132.104 74.6162 133.063 73.7819 134.407 73.5773V72.5382H135.726Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_9348_204)">
        <rect
          x="127.645"
          y="69.9679"
          width="14.5552"
          height="14.515"
          fill="white"
        />
      </g>
      <path
        d="M73.6203 111.734H107.595V121.202C107.595 121.818 107.096 122.316 106.481 122.316H74.7342C74.119 122.316 73.6203 121.818 73.6203 121.202V111.734Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.367 113.962H75.8481V120.089H105.367V113.962ZM73.6203 111.734V121.202C73.6203 121.818 74.119 122.316 74.7342 122.316H106.481C107.096 122.316 107.595 121.818 107.595 121.202V111.734H73.6203Z"
        fill="#292A33"
      />
    </g>
  </svg>
);

export default KioskImage;
